// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:44:09

export default {
  "id": "sigma-boy-musical-clicker",
  "slug": "sigma-boy-musical-clicker",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/9d577e41726143709a5c6ba72d044503-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/9d577e41726143709a5c6ba72d044503/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sigma Boy: Musical Clicker",
      "description": "To get started with Sigma Boy: Musical Clicker, simply tap on Sigma Boy to earn points. Use these points to purchase upgrades that boost Sigma Boy's abilities. As Sigma Boy evolves, he will move from the desert to new, more advanced environments, eventually embarking on a cosmic journey. Each level presents unique challenges, so keep clicking, upgrading, and evolving to help Sigma Boy conquer them all.",
      "instructions": "To get started with Sigma Boy: Musical Clicker, simply tap on Sigma Boy to earn points. ",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "clicker",
        "idle",
        "manager",
        "upgrade"
      ]
    },
    "zh-CN": {
      "title": "Sigma Boy：音乐点击器",
      "description": "开始玩Sigma Boy: 音乐点击器，只需点击Sigma Boy来获得积分。用这些积分购买升级，以增强Sigma Boy的能力。随着Sigma Boy的成长，他将从沙漠移动到更先进的新环境，最终踏上宇宙之旅。每个关卡都带来独特的挑战，所以继续点击、升级和成长，帮助Sigma Boy征服所有关卡。",
      "instructions": "要开始玩Sigma Boy: Musical Clicker，只需轻触Sigma Boy来获得积分。",
      "genres": [
        "冒险"
      ],
      "tags": [
        "点击器",
        "休闲",
        "管理",
        "升级"
      ]
    },
    "zh-TW": {
      "title": "西格瑪男孩：音樂點擊器",
      "description": "要開始玩Sigma Boy: Musical Clicker，只需輕觸Sigma Boy來獲得分數。使用這些分數來購買升級，提升Sigma Boy的能力。隨著Sigma Boy的進化，他將從沙漠移至新、更先進的環境，最終啟程於宇宙之旅。每個關卡都會帶來獨特的挑戰，所以請持續點擊、升級和進化，以幫助Sigma Boy征服所有關卡。",
      "instructions": "要開始玩Sigma Boy: Musical Clicker，請簡單點擊Sigma Boy來獲得分數。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "點擊器",
        "休閒",
        "管理員",
        "升級"
      ]
    },
    "zh-HK": {
      "title": "Sigma Boy：音樂點擊器",
      "description": "要開始玩Sigma Boy: Musical Clicker，簡單地點擊Sigma Boy來獲得分數。使用這些分數來購買升級，以提升Sigma Boy的能力。隨著Sigma Boy的進化，他將從沙漠移動到更多、更先進的環境，最終踏上一場宇宙之旅。每個關卡都帶來獨特的挑戰，所以繼續點擊、升級和進化，以幫助Sigma Boy征服所有關卡。",
      "instructions": "要開始玩Sigma Boy: Musical Clicker，只需輕觸Sigma Boy以獲得分數。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "點擊器",
        "閒置",
        "經理",
        "升級"
      ]
    },
    "ja": {
      "title": "シグマボーイ：音楽クリッカーシステム",
      "description": "シグマボーイ：ミュージカルクリッカーゲームを始めるには、シグマボーイをタップしてポイントを獲得してください。これらのポイントを使って、シグマボーの能力を強化するアップグレードを購入してください。シグマボーイは進化し、砂漠からより高度な新しい環境へと移動し、ついに宇宙の旅に出ることになります。各レベルにはユニークな挑戦が用意されており、シグマボーイが全てを克服するために、常にクリックし、アップグレードし、進化していきましょう。",
      "instructions": "シグマボーイ：ミュージカルクリッカーより始めるには、シグマボーイをタップしてポイントを獲得してください。",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "クリッカーゲーム",
        "アイドル",
        "マネージャー",
        "アップグレード"
      ]
    },
    "ko": {
      "title": "시그마 보이: 음악 클리커",
      "description": "Sigma Boy: Musical Clicker를 시작하려면 단순히 Sigma Boy을 탭하여 점수를 얻어주세요. 이 점수를 사용하여 Sigma Boy의 능력을 강화하는 업그레이드를 구매하세요. Sigma Boy이 진화하면서 사막에서 새로운, 더 진보된 환경으로 이동하게 되고, 결국 우주 여행에 나선다. 각 레벨은 독특한 도전을 제공하므로, Sigma Boy이 모든 도전을克服할 수 있도록 계속 클릭하고 업그레이드하고 진화하세요.",
      "instructions": "시그마보이: 음악 클리커를 시작하기 위해 단순히 시그마보이를 탭하여 점수를 얻으세요.",
      "genres": [
        "모험"
      ],
      "tags": [
        "클릭러",
        "아이들",
        "매니저",
        "업그레이드"
      ]
    },
    "fr": {
      "title": "Sigma Boy : Musical Clicker",
      "description": "Pour commencer avec Sigma Boy: Musical Clicker, il suffit de cliquer sur Sigma Boy pour gagner des points. Utilisez ces points pour acheter des améliorations qui renforcent les capacités de Sigma Boy. À mesure que Sigma Boy évolue, il passera de la désert à de nouveaux environnements plus avancés, eventually s'embarquant pour un voyage cosmique. Chaque niveau présente des défis uniques, donc continuez à cliquer, à améliorer et à évoluer pour aider Sigma Boy à les conquérir tous.",
      "instructions": "Pour commencer avec Sigma Boy: Musical Clicker, tapez simplement sur Sigma Boy pour gagner des points.",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "cliqueter",
        "idle",
        "gestionnaire",
        "mise à niveau"
      ]
    }
  }
};
